import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const VportCloseIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 20"
      strokeWidth={strokeWidth}
    >
      <path
        d="M18 14C17.4 14 17 14.4 17 15V18H2V6H7.9C8.5 6 8.9 5.6 8.9 5C8.9 4.4 8.5 4 7.9 4H1C0.4 4 0 4.4 0 5V19C0 19.6 0.4 20 1 20H18C18.6 20 19 19.6 19 19V15C19 14.4 18.6 14 18 14Z"
        fill={color}
      />
      <path
        d="M17.9 7.5L23.7 1.7C24.1 1.3 24.1 0.7 23.7 0.3C23.3 -0.1 22.7 -0.1 22.3 0.3L16.5 6.1L10.7 0.3C10.3 -0.1 9.7 -0.1 9.3 0.3C8.9 0.7 8.9 1.3 9.3 1.7L15.1 7.5L9.3 13.3C8.9 13.7 8.9 14.3 9.3 14.7C9.7 15.1 10.3 15.1 10.7 14.7L16.5 8.9L22.3 14.7C22.7 15.1 23.3 15.1 23.7 14.7C24.1 14.3 24.1 13.7 23.7 13.3L17.9 7.5Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

VportCloseIcon.displayName = 'VportCloseIcon';
